import React from "react";
import Helmet from "react-helmet";

function SEO (props) {
  return (
    <Helmet>
      {/* General tags */}
      <title>{props.title}</title>
      <meta name="description" content={props.description} />
      <meta name="image" content={props.imgUrl} />
      <link rel="canonical" href={props.url} />

      {/* OpenGraph tags */}
      <meta property="og:url" content={props.url} />
      <meta property="og:title" content={props.title} />
      <meta property="og:description" content={props.description} />
      <meta property="og:image" content={props.imgUrl} />

      {/* Twitter card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content="@inputsenpai" />
      <meta name="twitter:title" content={props.title} />
      <meta name="twitter:description" content={props.description} />
      <meta name="twitter:image" content={props.imgUrl} />
    </Helmet>
  )
}

export default SEO;